export default "__VITE_ASSET__DTx6cEv3__"